import validate from 'validate.js';
import {differenceInMinutes, parseJSON} from 'date-fns';

const constraints = {
  nombre: {
    presence: {
      allowEmpty: false,
      message: 'es obligatorio'
    }
  },
  email: {
    presence: {
      allowEmpty: false,
      message: 'es obligatorio'
    }
  },
};

export const validaUsuario = usuario => {
  let validacion = {};

  if (usuario) {
    validacion = validate(usuario, constraints) || {};
    if ((usuario.password || usuario.password2) && usuario.password !== usuario.password2) {
      validacion.password = ['Las contraseñas no coinciden'];
    }
  }

  return validacion;
}